import { render, staticRenderFns } from "./WarpingDeliveryView.vue?vue&type=template&id=881d3512&scoped=true"
import script from "./WarpingDeliveryView.vue?vue&type=script&lang=js"
export * from "./WarpingDeliveryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881d3512",
  null
  
)

export default component.exports